import React, { useState, useEffect, useRef } from 'react';
import FieldSelect from '../fields/FieldSelect';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { getFieldStatusProps } from '../../selectors/defaultSelectors';
import CheckoutNewAddressForm from './CheckoutNewAddressForm';
import Select, { components } from 'react-select';
import ReactLoading from 'react-loading';

const FORM_LABEL = {
    BillingAddressID: getTranslation('FIELD.BILLING_ADDRESS'),
};
const DropdownIndicator = (props) => {
    const { indicatorText } = props.selectProps;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {indicatorText}
            </components.DropdownIndicator>
        )
    );
};

const Option = (props) => {
    const { data } = props;
    let { className } = props;

    if (typeof data.className != 'undefined') {
        className += ' ' + data.className;
    }
  
    return (
        components.Option && (
            <components.Option {...props}   className={className}  />
        )
    );
};


function CheckoutBillingAddress(props) {
    const {
        isLoading,
        formData,
        fieldRefs,
        fieldStatus,
        handleBillingAddressLabel,
        handleFormUpdate,
        requestUserInfo,
        handleFormUpdateBillingAddress,
        availableAddresses,
        handleNewAddressSubmission,
        allowAddNewAddress,
    } = props;
    const [offset, setOffset] = useState(0); // Initial offset
    const [limit, setLimit] = useState(5);
    const [inputValue, setInputValue] = useState('');
    const showNewAddressForm = formData.BillingAddressID === 'add-new-address';
    let availableAddressesSelect = [
        {
            label: getTranslation('SELECT_BILLING_ADDRESS'),
            value: 0,
        },
        ...availableAddresses.map((item) => {
            return {
                label: item.FullAddress,
                value: item.ID,
            };
        }),
    ];
    const debounce = (func, wait) => {
        let timeout;
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };
    const handleDebouncedInputChange = debounce((value) => {
        setInputValue(value);
        handleInputChange(value);
     
    }, 1000);

    // handle input change event
    const handleInputChange = (value) => {
        requestUserInfo(0, 5, value).then((results) => {
        });
    };
    if (allowAddNewAddress) {
        availableAddressesSelect = [
            ...availableAddressesSelect,
            {
                label: getTranslation('ADD_NEW_BILLING_ADDRESS'),
                value: 'add-new-address',
            },
        ];
        // Add "Add new address" to dropdown, see checkout.html template
    }
    const findBusinessNameById = (id) => {
        const numericId = Number(id);
        const business = availableAddressesSelect.find(
            (business) => business.value == numericId
        );
        return business ? business.label : 'Select Billing Address';
    };
    const IndicatorsContainer = (props) => {
        const { limit, value, isMulti } = props.selectProps;
    
        if (isMulti && (typeof value == 'Array' && value.length >= limit))
            return null;
        return <components.IndicatorsContainer  onClick={findBusinessNameById('')} {...props} />;
    };      
    
    const selectedInputValue = findBusinessNameById(formData.BillingAddressID  );
    console.log(
        'selectedInputValuebilling',selectedInputValue
    )
    const renderLoading = () => {
        if (!isLoading) return null;
        return (
            <ReactLoading
                type='spin'
                color='black'
                height={20}
                width={20}
                className='button__spinner'
            />
        );
    };
    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <i className='icon icon-business' />
                    </span>
                </span>

                <h5 className='heading--lv5 heading'>
                    <LocalizedMessage id={'CHECKOUT.BILLING_ADDRESS.HEADING'} />
                </h5>
            </div>
            <div className='card__content'>
                <div className='form__highlight all-options'>
                    <div className='field field--filled'>
                            <Select
                                required
                                ref={(r) => (fieldRefs.BillingAddressID = r)}
                                fieldClasses='field__input'
                                className='react-select__container'
                                classNamePrefix='react-select'
                                isMulti={false}
                                isSearchable={true}
                                isClearable={true}
                                limit={1}
                                // end custom props
                                components={{
                                    IndicatorsContainer,
                                    DropdownIndicator,
                                    Option,
                                }}
                                indicatorText={''}
                                onInputChange={(value, actionMeta) => {
                                  
                                    if (
                                        actionMeta.action === 'input-change'
                                    ) {
                                        handleDebouncedInputChange(value);
                                    } else {
                                       
                                        handleBillingAddressLabel(
                                            'BillingAddressLabel',
                                            ''
                                        );
                                    }
                                }}
                                
                                isLoading={isLoading}
                                label={FORM_LABEL['BillingAddressID']}
                                animatedLabel={FORM_LABEL['BillingAddressID']}
                                name='BillingAddressID'
                                options={availableAddressesSelect}
                                defaultValue={{
                                    label:
                                    selectedInputValue || formData.BillingAddressLabel ,
                                    value:
                                    selectedInputValue || formData.BillingAddressLabel ,
                                }}
                                value={{
                                    label:
                                    selectedInputValue || formData.BillingAddressLabel ,
                                }}
                                onChange={(name, value) => {
                                    if (value.action == 'clear') {
                                        handleFormUpdateBillingAddress(
                                            value.name,
                                            ''
                                        );
                                        requestUserInfo();
                                    } else {
                                        handleFormUpdateBillingAddress(
                                            name,
                                            value
                                        );
                                    }
                                }}
                            />
                            {renderLoading()}
                           </div>
                    
                    <div
                        className='collapse new-content'
                        style={{
                            display: showNewAddressForm ? 'block' : 'none',
                        }}
                    >
                        <CheckoutNewAddressForm
                            handleFormSubmission={handleNewAddressSubmission}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default CheckoutBillingAddress;

